import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';
import { ID_SCAN_FIELDS } from './id-scan-field';

export default Factory.extend({
  kind: 'text',

  name() {
    return faker.lorem.words(15);
  },

  localized() {
    return faker.lorem.words(15);
  },

  identifier: '',
  required: false,
  position: (i) => i,

  allowEmployeeRespondents: true,
  allowVisitorRespondents: true,
  autoPopulatePreviousResponse: true,

  idScanField: null,

  asSingleSelectionWithOptions: trait({
    options: [1, 2, 3].map((el) => ({ id: `${el}`, value: `option ${el}` })),
    kind: 'single-selection',
  }),

  asEmailAddress: trait({
    kind: 'email',
    name: 'Your Email Address',
    localized: 'Your Email Address',
    identifier: 'email',
    required: false,
    position: 1,
    allowEmployeeRespondents: true,
    allowVisitorRespondents: true,
    autoPopulatePreviousResponse: true,
  }),

  asPhoneNumber: trait({
    kind: 'phone',
    name: 'Your Phone Number',
    localized: 'Your Phone Number',
    identifier: 'phone',
    required: false,
    position: -1,
    allowEmployeeRespondents: true,
    allowVisitorRespondents: true,
    autoPopulatePreviousResponse: true,
  }),

  asFullName: trait({
    kind: 'text',
    name: 'Your Full Name',
    localized: 'Your Full Name',
    identifier: 'name',
    required: true,
    position: 0,
    allowEmployeeRespondents: true,
    allowVisitorRespondents: true,
    autoPopulatePreviousResponse: true,
  }),

  asHost: trait({
    kind: 'host',
    name: 'Host',
    localized: 'Host',
    identifier: 'host',
    required: false,
    allowEmployeeRespondents: true,
    allowVisitorRespondents: true,
    autoPopulatePreviousResponse: true,
  }),

  asCompany: trait({
    kind: 'text',
    name: 'Company',
    localized: 'Company',
    identifier: 'company',
    required: true,
    storeResponse: true,
    allowEmployeeRespondents: true,
    allowVisitorRespondents: true,
    autoPopulatePreviousResponse: true,
  }),

  asCity: trait({
    kind: 'text',
    name: 'City',
    localized: 'City',
    identifier: 'locality',
    required: true,
    storeResponse: true,
    allowEmployeeRespondents: true,
    allowVisitorRespondents: true,
    autoPopulatePreviousResponse: true,
  }),

  asRequiredByEmployee: trait({
    kind: 'text',
    name: 'Required by Employee',
    localized: 'Required by Employee',
    required: true,
    storeResponse: false,
    allowEmployeeRespondents: true,
    allowVisitorRespondents: false,
    autoPopulatePreviousResponse: false,
  }),

  asText: trait({
    kind: 'text',
  }),

  asIdField: trait({
    kind: 'text',
    required: false,
    allowVisitorRespondents: false,
    idScanField: (i) => ID_SCAN_FIELDS[i % ID_SCAN_FIELDS.length].id,
  }),
});
